import HttpFactory from "~/repository/factory";

export interface UploadedPart {
  etag: string;
  partNumber: number;
}

class StorageModule extends HttpFactory {
  /**
   * Envia um chunk binário para uma URL pré-assinada
   * @param url URL gerada pelo backend (presigned URL do S3 para a parte)
   * @param data Blob/Chunk do áudio
   */
  async uploadPart(url: string, data: Blob): Promise<string> {
    const response = await fetch(url, {
      method: "PUT",
      body: data,
      headers: {
        "Content-Type": data.type || "application/octet-stream",
      },
    });

    if (!response.ok)
      throw new Error("Falha no upload da parte para o Storage");

    const etag = response.headers.get("ETag");
    return etag ? etag.replace(/"/g, "") : "";
  }
}

export default StorageModule;
